import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    deleteUrl: String,
  }

  connect() {
    this.#hideClipboardOnOldSafari()
  }

  deleteAccount(event) {
    event.preventDefault()

    const confirmation = "delete the account with all its contents"
    const text = prompt(
      `To confirm the account deletion enter: '${confirmation}'\n` +
      "Please note deleting an account is permanent and cannot be undone. " +
      "Once deleted, your apps and all your data cannot be restored."
    )

    if (text === confirmation) {
      $.delete(this.deleteUrlValue, () => {
        document.location = "/"
      })
    }
  }

  copy(event) {
    event.preventDefault()

    const link = event.currentTarget
    const inputId = link.id.substring(2)
    const input = document.getElementById(inputId)
    if (!input) return

    input.select()
    document.execCommand("copy")
  }

  #hideClipboardOnOldSafari() {
    const safari = navigator.userAgent.match(/Version\/[\d.]+.*Safari/)
    if (!safari) return

    const versionMatch = safari[0].match(/\d{1,}/)
    if (safari[0] && versionMatch && Number(versionMatch[0]) <= 9) {
      this.element.querySelectorAll(".clipboard").forEach((el) => el.remove())
    }
  }
}
